module.exports = __webpack_public_path__ + "img/hzkh@2x.ff10c7df.png";